export default __webpack_public_path__ + "static/media/back.81622792.svg";